/**
 * AITab - Smart features tab for NavigationCustomization
 * AI auto-ordering toggle and settings
 */
import { Sparkles, Zap } from 'lucide-react'
import { cn } from '../../lib/utils'

interface AITabProps {
  aiEnabled: boolean
  onToggle: () => void
}

export function AITab({ aiEnabled, onToggle }: AITabProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-4 p-4 bg-violet-50 dark:bg-violet-900/20 border border-violet-200 dark:border-violet-800 rounded-xl">
        <div className="w-10 h-10 rounded-lg bg-violet-100 dark:bg-violet-900/50 flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-5 h-5 text-violet-600 dark:text-violet-400" />
        </div>
        <div>
          <h3 className="text-sm font-medium text-slate-700 dark:text-slate-200">
            AI-Powered Navigation
          </h3>
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
            Quotech learns from your navigation patterns and automatically reorders
            menu items to put your most-used pages near the top.
          </p>
        </div>
      </div>
      
      <div className="flex items-center justify-between p-4 border border-slate-200 dark:border-slate-700 rounded-xl">
        <div className="flex items-center gap-3">
          <Zap className="w-5 h-5 text-amber-500" />
          <div>
            <p className="text-sm font-medium text-slate-700 dark:text-slate-200">
              Smart Auto-Ordering
            </p>
            <p className="text-xs text-slate-500">
              Automatically sort nav items by usage
            </p>
          </div>
        </div>
        <button
          onClick={onToggle}
          className={cn(
            'relative w-11 h-6 rounded-full transition-colors',
            aiEnabled ? 'bg-teal-500' : 'bg-slate-300 dark:bg-slate-600'
          )}
        >
          <div className={cn(
            'absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-transform',
            aiEnabled && 'translate-x-5'
          )} />
        </button>
      </div>
      
      <div className="text-xs text-slate-400 text-center">
        Navigation usage is stored locally on your device
      </div>
    </div>
  )
}
